module.exports = __webpack_public_path__ + "media/images/icon__checkmark-0992ba0ff58f8746f3545e3dc7758bc4.png";